import ServicesApi from './ServicesApi';

export default class SessionApi {
  static servicePrefix = 'sessionservice/';

  static async getSessionInfo() {
    const headers = await ServicesApi.getHeaders();

    const sessionInfoResponse = await fetch(
      SessionApi.servicePrefix + 'session-info', {
      method: 'GET',
      headers: headers
    });

    return await sessionInfoResponse.json();
  }

  static async getTableauAuthorization(counterpartyCode) {
    const headers = await ServicesApi.getHeaders();

    const updateResponse = await fetch(
      SessionApi.servicePrefix + 'tableau-authorization?counterpartyCode=' + counterpartyCode, {
      method: 'GET',
      headers: headers
    });

    return await updateResponse.json();
  }

  static async getCounterpartyLogo(counterpartyCode) {
    const headers = await ServicesApi.getHeaders();

    const updateResponse = await fetch(
      SessionApi.servicePrefix + 'counterparty-logo?counterpartyCode=' + counterpartyCode, {
      method: 'GET',
      headers: headers
    });

    return await updateResponse.json();
  }

    static async getApplicationInfo() {
        const applicationResponse = await fetch(
            SessionApi.servicePrefix + 'application-info',
            { method: 'GET' }
        );
        return await applicationResponse.json();
    }
}